export default __webpack_public_path__ + "static/media/home_title.ad71eefb.svg";